import dotenv from 'dotenv';
import path from 'path';

const envPath = path.resolve(__dirname, '../.env');
dotenv.config({ path: envPath });

const KEY = process.env.GOOGLE_MAPS_API_KEY;
window.KEY = KEY;
const script = document.createElement('script');
script.src = `https://maps.googleapis.com/maps/api/js?key=${KEY}&libraries=places`;
script.async = true;
document.head.appendChild(script);
const urlApi = process.env.API_URL;
window.urlApi = urlApi;
